import React from "react";
import { Box, Text, Link } from "@chakra-ui/react";

const EXCLUDED_USER_IDS: string[] = [
  "b19464fa-adc9-4837-9ffa-38e8baec87ce",
  "74a8d1eb-aaf4-4a62-aeee-3a3e353bcb1f",
  "99485eda-2d5c-490c-b16e-584bac6df67c",
  "bdd0e7a5-a8ef-4a51-a30b-bbecd803e94b",
  "f83635c5-1cb5-4c7e-93a2-6f0203720913",
  "6ea65304-38bc-4485-8c00-e5326872d721",
  "3fea06ef-615f-4eeb-a778-77f5fe7886b9",
  "cd92a089-ce9a-4b93-b4d6-5ef5cd088668",
  "41e05d9f-2fd6-4fb1-8200-37d2c45330c2",
  "ec9cc792-b85e-4a33-9af4-f26a4526834e",
  "ba8fb1e5-3ff4-4e80-bd79-5463421e8d8e",
];

const BANNER_START_DATE = new Date("2099-02-09T00:00:00");

interface DismissalBannerProps {
  userId?: string;
}

export const DismissalBanner: React.FC<DismissalBannerProps> = ({ userId }) => {
  const currentDate = new Date();

  // Don't show banner before the start date
  if (currentDate < BANNER_START_DATE) {
    return null;
  }

  // Don't show banner for excluded users
  if (!userId || EXCLUDED_USER_IDS.includes(userId)) {
    return null;
  }

  return (
    <Box
      bg="#FEF3C7"
      borderBottom="1px solid #F59E0B"
      px={4}
      py={3}
      width="100%"
    >
      {/* @ts-ignore - Chakra UI complex type issue */}
      <Text fontWeight="bold" color="#92400E" mb={1}>
        ATTENZIONE: PIATTAFORMA DISMESSA
      </Text>
      {/* @ts-ignore - Chakra UI complex type issue */}
      <Text color="#92400E" fontSize="sm">
        La pianificazione e rendicontazione delle attività si è spostata. Non
        inserire dati su questa piattaforma, non verranno salvati.{" "}
        <Link
          href="https://larin.timetrap.it"
          color="#B45309"
          fontWeight="semibold"
          textDecoration="underline"
          isExternal
        >
          Vai al nuovo indirizzo: larin.timetrap.it
        </Link>
      </Text>
    </Box>
  );
};
